import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService, AAGUID } from '@interticket/core';
import { IMediaSource } from '@core/interfaces/media/media-source.interface';
import { ILivestreamStatus } from '@core/interfaces/media/livestream-status.interface';

@Injectable()
export class MediaSourceService implements IMediaSource {

  private readonly streamBaseUrl: string = `/v2/media/stream`;

  constructor(
    private httpService: HttpService
  ) { }

  getStreamableEvents(): Observable<AAGUID[]> {
    return this.httpService.get<AAGUID[]>(`${this.streamBaseUrl}/events/access`);
  }

  getLivestreamStatus(eventId: AAGUID): Observable<ILivestreamStatus> {
    return this.httpService.get(`${this.streamBaseUrl}/${eventId}/vod`);
  }

}
